export default __webpack_public_path__ + "static/media/nft-awe.554edf92.jpg";